
import React from "react";
import { SessionDataManagedNotice } from "@/components/welcome/components/SessionDataManagedNotice";

interface SessionsHeaderProps {
  title?: string;
  description?: string;
  isInvitedUser?: boolean;
  /** When true (the Sessions tab of /welcome), render the session-data notice directly above the title. */
  isWelcomeScreen?: boolean;
}

export const SessionsHeader: React.FC<SessionsHeaderProps> = ({
  title = "Session planning",
  description = "Schedule sessions and manage availability for your camp programs",
  isInvitedUser = false,
  isWelcomeScreen = false
}) => {
  // Use slightly different text for invited users
  const invitedDescription = "Schedule and manage sessions for this camp location";
  const finalDescription = isInvitedUser ? invitedDescription : description;

  return (
    <div className="text-left">
      {isWelcomeScreen && (
        <div className="mb-3">
          <SessionDataManagedNotice />
        </div>
      )}
      <h2 className="text-xl font-semibold mb-1 text-left">{title}</h2>
      <p className="text-muted-foreground">
        {finalDescription}
      </p>
      {isInvitedUser && !isWelcomeScreen && (
        <div className="mt-3">
          <SessionDataManagedNotice />
        </div>
      )}
    </div>
  );
};
